import { Injectable } from '@angular/core';
import { BaseBackend } from '@shared/apis/servers/base-backend';

@Injectable({
  providedIn: 'root'
})
export class ExtendSerialBackendServer extends BaseBackend {
  getExtendSerials(builder) {
    return this.get('/b2b-extend-serials', { params: builder });
  }

  getExtendSerialBySerialNo(serialNo) {
    return this.get(`/b2b-extend-serials/${ serialNo }`)
  }

  saveExtendSerial(extendSerialInfo) {
    return this.post('/b2b-extend-serials', extendSerialInfo);
  }

  editExtendSerial(extendSerialInfo) {
    return this.patch(`/b2b-extend-serials/${ extendSerialInfo.serialNo }`, extendSerialInfo);
  }

  deleteExtendSerial(extendSerialDetail) {
    return this.delete(`/b2b-extend-serials/${ extendSerialDetail.serialNo }`, extendSerialDetail);
  }
}
